import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const toolsData = [
  {
    id: 1,
    title: 'CICLOP',
    description: 'CICLOP is a web based tool for Characterization of Inner Cavity Lining of Proteins.',
    imageUrl: require("../../assets/tools/ciclopImage.png"),
    link: 'https://ciclop.raylab.iiitd.edu.in/'      // Replace with actual website URL
  },
  {
    id: 2,
    title: 'DIGEST',
    description: 'DIGEST is a A web based tool to offer a novel alternative for rapid design of MRM transitions for proteomics research.',
    imageUrl: require("../../assets/tools/digestImage.png"), 
    link: 'https://digest.raylab.iiitd.edu.in/'      // Replace with actual website URL
  }
];

const ToolsPage = () => {
  return (
    <div className="container mx-auto py-12 px-4">
      <h1 className="text-5xl font-bold text-designColor text-center mb-8">Our Tools</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {toolsData.map(tool => (
          <div key={tool.id} className="bg-white shadow-lg rounded-lg overflow-hidden">
            <img src={tool.imageUrl} alt={tool.title} className="w-full h-64 object-cover"/>
            <div className="p-6">
              <h2 className="text-2xl font-bold mb-4">{tool.title}</h2>
              <p className="text-gray-700 mb-4">{tool.description}</p>
              <a href={tool.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                Visit {tool.title} Website
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ToolsPage;
